import React from 'react';

const HelpIcon = () => {
  const handleClick = () => {
    if (window.Intercom) {
      window.Intercom('show');
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: 'rgba(24, 15, 34, 0.8)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 1001,
        fontSize: '18px',
        color: '#fff',
        fontWeight: 'bold',
        transition: 'all 0.2s ease',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'rgba(59, 130, 246, 0.8)';
        e.target.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'rgba(24, 15, 34, 0.8)';
        e.target.style.transform = 'scale(1)';
      }}
      title="Get Help"
    >
      ?
    </div>
  );
};

export default HelpIcon; 